import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext, useState, useCallback } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { Button, Icon } from '../index';
import usePopper from '../_utils/usePopper';
import { toArray } from '../_utils/react-children';
import { tuple } from '../_utils/type';
export var ButtonGroupTypes = tuple('basic', 'similar');

var InternalButtonGroup = function InternalButtonGroup(props, ref) {
  var _context;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var buttonGoupProps = getCompProps('ButtonGroup', userDefaultProps, props);
  var style = buttonGoupProps.style,
      className = buttonGoupProps.className,
      children = buttonGoupProps.children,
      customPrefixcls = buttonGoupProps.prefixCls,
      onClick = buttonGoupProps.onClick,
      onItemClick = buttonGoupProps.onItemClick,
      overlay = buttonGoupProps.overlay,
      icon = buttonGoupProps.icon,
      type = buttonGoupProps.type,
      buttonType = buttonGoupProps.buttonType,
      disabled = buttonGoupProps.disabled,
      onVisibleChange = buttonGoupProps.onVisibleChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      optionShow = _useState2[0],
      setOptionShow = _useState2[1]; // 下拉列表是否展示


  var refBtnGroup = React.useRef(null) || ref;
  var triggerRef = React.useRef(null);
  var isBsicType = type === 'basic';
  var btnGroupPrefixCls = getPrefixCls(prefixCls, 'btn-group', customPrefixcls);
  var btnGroupClasses = classNames("".concat(btnGroupPrefixCls), className, _defineProperty({}, _concatInstanceProperty(_context = "".concat(btnGroupPrefixCls, "-")).call(_context, type), type));
  var renderTriggerButton = useCallback(function () {
    var _toArray = toArray(icon),
        _toArray2 = _slicedToArray(_toArray, 2),
        _toArray2$ = _toArray2[0],
        iconUp = _toArray2$ === void 0 ? /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-up"
    }) : _toArray2$,
        _toArray2$2 = _toArray2[1],
        iconDown = _toArray2$2 === void 0 ? /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down"
    }) : _toArray2$2;

    return /*#__PURE__*/React.createElement("div", {
      style: style,
      className: btnGroupClasses,
      ref: refBtnGroup
    }, isBsicType && /*#__PURE__*/React.createElement(Button, {
      type: buttonType,
      disabled: disabled
    }, children, /*#__PURE__*/React.createElement("span", {
      className: "".concat(btnGroupPrefixCls, "-basic-icon")
    }, optionShow ? iconUp : iconDown)), !isBsicType && /*#__PURE__*/React.createElement(Button, {
      type: buttonType,
      disabled: disabled,
      onClick: onClick
    }, children), !isBsicType && /*#__PURE__*/React.createElement("span", {
      className: "".concat(btnGroupPrefixCls, "-trigger"),
      ref: triggerRef
    }, optionShow ? /*#__PURE__*/React.createElement(Button, {
      icon: iconUp,
      type: buttonType,
      disabled: disabled
    }) : /*#__PURE__*/React.createElement(Button, {
      icon: iconDown,
      type: buttonType,
      disabled: disabled
    })));
  }, [icon, btnGroupPrefixCls, style, btnGroupClasses, refBtnGroup, isBsicType, buttonType, disabled, children, optionShow, onClick]);
  var handleItemClick = useCallback(function (data) {
    onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(data);
    setOptionShow(false);
  }, [onItemClick]);
  var renderContent = useCallback(function () {
    var _context2;

    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(btnGroupPrefixCls, "-dropdown")
    }, _mapInstanceProperty(_context2 = overlay || []).call(_context2, function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.value,
        className: "".concat(btnGroupPrefixCls, "-dropdown-item"),
        onClick: function onClick() {
          return handleItemClick === null || handleItemClick === void 0 ? void 0 : handleItemClick(item);
        }
      }, item.label);
    }));
  }, [btnGroupPrefixCls, overlay, handleItemClick]);

  var handleVisibleChange = function handleVisibleChange(visible) {
    setOptionShow(visible);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visible);
  };

  var popperProps = _extends(_extends({
    placement: 'bottomLeft',
    trigger: 'click',
    gap: 0
  }, buttonGoupProps), {
    prefixCls: btnGroupPrefixCls,
    defaultVisible: optionShow,
    visible: optionShow,
    onVisibleChange: handleVisibleChange,
    getTriggerElement: function getTriggerElement(locatorNode) {
      return isBsicType ? locatorNode : triggerRef.current;
    }
  });

  return usePopper(renderTriggerButton(), renderContent(), popperProps);
};

var ButtonGroup = /*#__PURE__*/React.forwardRef(InternalButtonGroup);
ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;